import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
  Alpine.data("video_carousel", () => {
    return {
      currentVideo: null,
      videos: [],
      links: [],
      isProgrammaticScroll: false,
      get step() {
        return Number(this.currentVideo.dataset.step)
      },
      get substep() {
        return Number(this.currentVideo.dataset.substep)
      },

      init() {
        this.$el.querySelectorAll(".videos").forEach((el) => this.videos.push([...el.querySelectorAll("video")]));

        this.$el.querySelectorAll("ul").forEach((el) => this.links.push([...el.querySelectorAll("li")]));

        // Only show first video of each step
        this.videos.forEach((stepVideos, stepIdx) => {
          stepVideos.forEach((video, substepIdx) => {
            video.classList.toggle("opacity-0", substepIdx != 0)

            video.dataset.step = stepIdx
            video.dataset.substep = substepIdx
            video.addEventListener("ended", this.onVideoEnded.bind(this));
          });
        });


        // Add event listeners to links
        this.links.forEach((stepLinks, stepIdx) => {
          stepLinks.forEach((link, substepIdx) => {
            link.dataset.step = stepIdx
            link.dataset.substep = substepIdx

            const isFirstLink = (stepIdx == 0 && substepIdx == 0)
            link.classList.toggle("opacity-50", !isFirstLink)
            link.classList.toggle("hover:opacity-100", !isFirstLink)
            link.classList.toggle("hover:opacity-90", isFirstLink)

            link.addEventListener("click", this.changeVideo.bind(this))
          })
        })

        // React to scroll events
        this.$root.addEventListener("scroll", this.onScroll.bind(this))
        this.$nextTick(() => {
          this.$root.scrollLeft = 0;
        });

        
        this.currentVideo = this.videos[0][0]
        this.previousVideo = this.currentVideo

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.currentVideo.play();
            } else {
              this.currentVideo.pause();
            }
          })
        }, {
          threshold: 0.5
        })

        observer.observe(this.$root)
        
        // React to video changes
        this.$watch("currentVideo", (newVideo) => {   // drop oldVideo param, it's unreliable
          this.isProgrammaticScroll = true
          
          const oldVideo = this.previousVideo          // <-- use our own tracked value
          this.previousVideo = newVideo                // <-- update for next time
          
          if (!oldVideo) { this.isProgrammaticScroll = false; return } // nothing to hide on first run
          
            console.log(newVideo, oldVideo)
            const prevStep = oldVideo.dataset.step
            const prevSubstep = oldVideo.dataset.substep

            let stepVideos = this.videos[this.step]

            if (this.step == prevStep) oldVideo.classList.add("opacity-0")
            oldVideo.pause()

            if (this.step != prevStep) {
              stepVideos.forEach((el) => { el.classList.add("opacity-0") })
            }

            this.links.forEach((stepLinks, stepIdx) => {
              stepLinks.forEach((link, substepIdx) => {
                const higlighted = !(stepIdx > this.step || (stepIdx == this.step && substepIdx > this.substep))
                link.classList.toggle("opacity-50", !higlighted)
                link.classList.toggle("hover:opacity-100", !higlighted)
                link.classList.toggle("hover:opacity-90", higlighted)
              })
            })

            newVideo.classList.remove("opacity-0")
            newVideo.currentTime = 0
            newVideo.play();

            this.isProgrammaticScroll = false
          });
      },

      onVideoEnded() {
        let step = this.step
        let substep = this.substep
        let stepVideos = this.videos[step]

        
        // Update step and substep
        if (substep == stepVideos.length - 1) {
          step = (step + 1) % this.videos.length;
        }
        substep = (substep + 1) % stepVideos.length;
        
        this.currentVideo = this.videos[step][substep]
        
        this.scrollToVideo()
      },

      scrollToVideo() {
        const carousel = this.$root
        // Scroll automatically to the slide
        const carouselItem = this.currentVideo.closest(".carousel-item")
        const left = carouselItem.offsetLeft - (carousel.clientWidth - carouselItem.clientWidth) / 2
        carousel.scrollTo({ left, behavior: 'smooth' })
      },

      onScroll() {
        const carousel = this.$root
        // Scroll automatically to the slide
        const slideWidth = carousel.clientWidth

        if (this.isProgrammaticScroll) return;

        clearTimeout(this._scrollEnd);
        this._scrollEnd = setTimeout(() => {
          const index = Math.round(
            this.$root.scrollLeft / slideWidth
          );

          if (index !== this.step) {
            this.currentVideo = this.videos[index][0]
          }
        }, 50);
      },

      changeVideo(e) {
        const link = e.target
        const step = link.dataset.step
        const substep = link.dataset.substep
        this.currentVideo = this.videos[step][substep]
      },

      destroy() {
        this.$root.removeEventListener("scroll", this.onScroll)

        this.videos.forEach((stepVideos) => {
          stepVideos.forEach((video) => {
            video.removeEventListener("ended", this.onVideoEnded);
          });
        });

        this.$el.querySelectorAll("ul").forEach((stepLinks) => {
          stepLinks.querySelectorAll("li").forEach((link) => {
            link.removeEventListener("click", this.changeVideo);
          })
        })
      },
    };
  });
});
